import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";

export const fetchSettings = createAsyncThunk("settings/fetch", async (_, { rejectWithValue }) => {
  try { const r = await api.get('/ConfigurationAgence'); return r.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const updateSettings = createAsyncThunk("settings/update", async (data, { rejectWithValue }) => {
  try { const r = await api.patch('/ConfigurationAgence', data); return r.data; }
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

export const resetSettings = createAsyncThunk("settings/reset", async (_, { rejectWithValue }) => {
  try { await api.delete('/ConfigurationAgence/reset'); return true; }
  catch (e) { return rejectWithValue(e.response?.data?.message || e.message); }
});

const slice = createSlice({
  name: "settings",
  initialState: { config: null, loading: false, error: null, success: false },
  reducers: {
    resetSuccess: (state) => { state.success = false; },
    clearError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
        // La langue est une préférence individuelle gérée dans authSlice — ne pas l'appliquer ici.
      })
      .addCase(fetchSettings.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(updateSettings.pending, (state) => { state.loading = true; state.error = null; state.success = false; })
      .addCase(updateSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
        state.success = true;
        // La langue est une préférence individuelle gérée dans authSlice — ne pas l'appliquer ici.
      })
      .addCase(updateSettings.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
    builder
      .addCase(resetSettings.pending, (state) => { state.loading = true; state.success = false; })
      .addCase(resetSettings.fulfilled, (state) => { state.loading = false; state.config = null; state.success = true; })
      .addCase(resetSettings.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export const { resetSuccess, clearError } = slice.actions;
export default slice.reducer;
